import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AccountCredit } from '../../models/account-credit.model';

/**
 * Client for the account credit ledger (/api/accounts/{id}/credits).
 */
@Injectable({ providedIn: 'root' })
export class AccountCreditService {
  private base(accountId: number): string {
    return `${environment.apiUrl}/api/accounts/${accountId}/credits`;
  }

  constructor(private http: HttpClient) {}

  getBalance(accountId: number): Observable<{ balance: number }> {
    return this.http.get<{ balance: number }>(`${this.base(accountId)}/balance`);
  }

  getHistory(accountId: number): Observable<AccountCredit[]> {
    return this.http.get<AccountCredit[]>(this.base(accountId));
  }

  apply(accountId: number, targetReturnId: number, amount: number): Observable<AccountCredit> {
    return this.http.post<AccountCredit>(`${this.base(accountId)}/apply`, { targetReturnId, amount });
  }
}
